import { Component } from '@angular/core';
import { FirebaseService } from '../../services/auth/firebase.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  constructor(public firebaseService: FirebaseService){}
}
